import { render, staticRenderFns } from "./MyVSelect.vue?vue&type=template&id=24d17212"
import script from "./MyVSelect.vue?vue&type=script&lang=js"
export * from "./MyVSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports